import React from 'react';

export default function PageNotFound() {
    return (
        <div style={{ textAlign: 'center', padding: '50px' }}>
            <h1>404</h1>
            <p>how did you even get here</p>
            <a href="/">link to homepage</a>
        </div>
    );
}